import Actions from '../actions'

const initialState = {
  productPlans: {
    data: {},
    isLoading: false
  },
  isLoadingScopeProducts: false,
  shippingFees: {},
  shippingFee: 0,
  scopePlanGroup: null,
  includesScopeLG: false,
  maxQuantityLG: null,
  maxQuantityLGMini: null,
  scope: {
    data: {}
  },
  scopeMini: {
    data: {}
  },
  scopeLG: {
    data: {}
  },
  scopeLGMini: {
    data: {}
  }
}

export default (state = initialState, action) => {
  switch (action.type) {
    case Actions.FETCH_GRIN_SCOPE_PRODUCTS:
      return {
        ...state,
        isLoadingScopeProducts: true
      }
    case Actions.FETCH_GRIN_SCOPE_PRODUCTS_RECEIVED:
      return {
        ...state,
        isLoadingScopeProducts: false,
        scopePlanGroup: action.payload?.requestedPlanGroup || state.scopePlanGroup,
        includesScopeLG: !!action.payload?.includeScopeLG,
        maxQuantityLG: action.payload?.maxQuantityLG ?? null,
        maxQuantityLGMini: action.payload?.maxQuantityLGMini ?? null,
        scope: {
          ...state.scope,
          data: action.payload.scope
        },
        scopeMini: {
          ...state.scopeMini,
          data: action.payload.scopeMini
        },
        scopeLG: {
          ...state.scopeLG,
          data: action.payload.scopeLG
        },
        scopeLGMini: {
          ...state.scopeLGMini,
          data: action.payload.scopeLGMini
        },
        shippingFee: action.payload?.shippingFee,
        shippingFees: action.payload?.shipping
      }
    case Actions.FETCH_GRIN_SCOPE_PRODUCTS_FAILED:
      return {
        ...state,
        isLoadingScopeProducts: false
      }
    case Actions.SIGNOUT_RECEIVED:
      return initialState
    default:
      return state
  }
}
